// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__sXi6K","ring":"Loader_ring__UFlL9"};